<div>
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>
<form #form1="ngForm" (keydown.enter)="handleEnter($event)">
  <div *ngIf="isDisplay">

    <ng-template #companyInfoTooltipContent>

      The Organization Information section allows you to enter information to identify your organization.<br />
      This includes:<p>
      <ul class="list-unstyled">
        <li><strong>Legal Entity Type: </strong>select or enter the business structure your organization operates under financially</li>
        <li><strong>Messaging Role: </strong>select the option that best describes your organization's role in the short code messaging ecosystem</li>
        <li><strong>Stock Market Symbol: </strong>your organization's stock market symbol, if it is publicly traded</li>
        @if (model.smbAware) {
          <li><strong>Estimated Annual Revenue: </strong>your organization's estimated annual revenue in USD. This information is not required, but some program incentives
            may be available to your account based upon the information provided</li>
          }
        <li><strong>Organization URL: </strong>your organization's web address</li>
        <li><strong>Federal Tax ID: </strong>your organization's Federal Employer ID Number or FEIN (Format: ##-#######)</li>
        <li><strong>Dun &amp; Bradstreet: </strong>your organization's DUNS (Format: 9 digits)</li>
        <li><strong>GIIN: </strong>your organization's Global Intermediary Identification Number, if one has been assigned (Format: XXXXXX.XXXXX.XX.XXX)</li>
        <li><strong>LEI: </strong>your organization's Legal Entity Identifier (Format: 20 characters)</li>
      </ul>
      <p></p>
      Typically your accounting department will have this information.<br />
      Please contact support at {{customerSupportPhone}} if you need assistance.


    </ng-template>

    <h5 class="mt-4 ">
      Organization Information
      <sup>
        <i class="fa fa-circle-info small" style="color: #004381; margin-left: .1em;" [pTooltip]="companyInfoTooltipContent"></i>
      </sup>
    </h5>
    @if (disableSmbFields) {
    <small>
      Some fields in this section are disabled at this time, because your account is being evaluated for eligibility for a promotional program.<br />
      When this evaluation is complete, you will receive a notification, and the fields will be re-enabled for editing.
    </small>
    }
    <div class="row mt-3">
      <div class="col-3 ">
        <span class=" fw-bold">Account ID: {{ model.accountId }}</span>
      </div>
      <div class="col-9 fw-bold truncate" [pTooltip]="model.company ? model.company: ''" tooltipPosition="top" appShowToolTipIfTruncated>Organization Name: {{ model.company }}
      </div>
    </div>

    <div class="row">
      <div class="col-3 ms-0">
        <label for="legalEntityType" class="required">Legal Entity Type</label>
        <p-dropdown [editable]="true" appDd placeholder="Enter or Select" [maxlength]="45" [options]="legalEntityTypes" [required]="true" id="legalEntityType"
          name="legalEntityType" #legalEntityType="ngModel" [(ngModel)]="model.legalEntityType" (onChange)="onChangeDropdown($event)"></p-dropdown>
        <app-error-msg [field]="legalEntityType" fieldLabel="Legal Entity Type"></app-error-msg>
      </div>


      <div class="col-4 ms-0">
        <label for="messagingRole" class="required">Messaging Role</label>
        <p-dropdown appDd placeholder="Select Messaging Role" [maxlength]="50" [options]="ecosystemRoles" [required]="true" id="messagingRole" name="messagingRole"
         #messagingRole="ngModel" [(ngModel)]="model.messagingRole" [disabled]="disableSmbFields"></p-dropdown>
        <app-error-msg [field]="messagingRole" fieldLabel="Messaging Role"></app-error-msg>
      </div>
    </div>



    <div class="row">
      <div class="col-3">
        <label for="companySymbol">Stock Market Symbol </label>
        <input appScrText appUppercase [(ngModel)]="model.companySymbol" name="companySymbol" id="companySymbol" #companySymbol="ngModel" mask="AAAAA" pattern=".*[A-Za-z].*"
          [validation]="false" placeholder="Stock Market Symbol" />
        <div>
          <ng-template [ngIf]="companySymbol.dirty && companySymbol.invalid && !companySymbol.errors?.required">
            <span class="failed">
              must be between 1 and 5 alphanumeric characters
            </span>
          </ng-template>
        </div>
      </div>
      @if (model.smbAware) {
      <div class="col-3">
        <label for="estimatedAnnualRevenueInput">Estimated Annual Revenue</label>
        <p-inputNumber appIn #estimatedAnnualRevenue="ngModel" mode="currency" currency="USD" locale="en-US" size="35" [disabled]="disableSmbFields"
          [(ngModel)]="model.estimatedAnnualRevenue" name="estimatedAnnualRevenue" id="estimatedAnnualRevenue" min="0.01" max="10000000000000"
          placeholder="Estimated Annual Revenue (in USD)"></p-inputNumber>
        <app-error-msg [form]="form1" [field]="estimatedAnnualRevenue" fieldLabel="Estimated Annual Revenue"></app-error-msg>
      </div>
      }
    </div>
    <div class="row">
      <div class="col-6 ms-0">
        <label for="companyUrl" class="required">Organization URL </label>
        <input appScrText appUrlValidator [(ngModel)]="model.companyUrl" name="companyUrl" id="companyUrl" #companyUrl="ngModel" placeholder="Organization URL"
          maxlength="{{MaxLen.CompanyUrl}}" required autocomplete="url" />
        <app-error-msg [form]="form1" [field]="companyUrl" fieldLabel="Organization URL"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <label for="fein" class="required">Federal Tax ID (##-#######)</label>
        <input appScrText [(ngModel)]="model.fein" #fein="ngModel" name="fein" id="fein" mask="00-0000000" [dropSpecialCharacters]="false" placeholder="**-*******" required />
        <app-error-msg [form]="form1" [field]="fein" fieldLabel="Federal Tax ID"></app-error-msg>
      </div>
      <div class="col-3">
        <label for="duns">Dun & Bradstreet (DUNS) 9 Digits</label>
        <input appScrText [(ngModel)]="model.duns" name="duns" id="duns" #duns="ngModel" mask="000000000" placeholder="9 Digits" />
        <app-error-msg [form]="form1" [field]="duns" fieldLabel="DUNS"></app-error-msg>
      </div>
    </div>

    <div class="row">
      <div class="col-3">
        <label for="giin" class="col-12">GIIN (XXXXXX.XXXXX.XX.XXX)</label>
        <input appUppercase appScrText #giin="ngModel" [(ngModel)]="model.giin" name="giin" id="giin" placeholder="GIIN" maxlength="19" mask="AAAAAA.AAAAA.AA.000"
          [dropSpecialCharacters]="false" pattern="[A-NP-Z\d]{6}\.[A-NP-Z\d]{5}\.(LE|SL|ME|BR|SP|SF|SD|SS|SB)\.\d{3}" [validation]="false" />
        <app-error-msg [field]="giin" fieldLabel="GIIN"></app-error-msg>
      </div>
      <div class="col-3">
        <label for="lei" class="col-6">LEI (20 Characters)</label>
        <div class="col-12">
          <input appUppercase appLei appScrText #lei="ngModel" [(ngModel)]="model.lei" name="lei" id="lei" placeholder="LEI" maxlength="20" pattern="[A-Z\d]{18}\d{2}" />
          <app-error-msg [field]="lei" fieldLabel="LEI"></app-error-msg>
        </div>
      </div>

    </div>

    <!-- Primary Account Contact -->
    <h5 class="mt-4 mb-0">Primary Account Contact</h5>
    <div class="row ">
      <div class="col-3 ">
        <label for="firstName" class="required">First Name </label>
        <input appScrText appFirstNameValidator [(ngModel)]="model.firstName" #firstName="ngModel" name="firstName" autocomplete="given-name" id="firstName"
          placeholder="First Name" maxlength="{{MaxLen.FirstName}}" required />
        <app-error-msg [form]="form1" [field]="firstName" fieldLabel="First Name"></app-error-msg>
      </div>

      <div class="col-3 ">
        <label for="lastName" class="required">Last Name </label>
        <input appScrText appLastNameValidator [(ngModel)]="model.lastName" #lastName="ngModel" name="lastName" autocomplete="family-name" id="lastName" placeholder="Last Name"
          maxlength="{{MaxLen.LastName}}" required />
        <app-error-msg [form]="form1" [field]="lastName" fieldLabel="Last Name"></app-error-msg>
      </div>
    </div>

    <div class="row">
      <div class="col-2 ">
        <label for="phoneInput" class="required">Phone Number</label>
        <app-phone [(ngModel)]="model.phone" #phone="ngModel" class="col-12" name="phone" required id="phone" autocomplete="tel"></app-phone>
        <app-error-msg [form]="form1" [field]="phone" fieldLabel="Phone Number"></app-error-msg>
      </div>
      <div class="col-1 ps-0">
        <label for="extension">Extension</label>
        <input appScrText [(ngModel)]="model.phoneExtension" maxlength="{{MaxLen.PhoneExtension}}" name="extension" autocomplete="tel-extension" id="extension" placeholder="" />
      </div>
      <div class="col-3  ">
        <label for="email" class="required">Email </label>
        <input appEmail appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" [(ngModel)]="model.email" name="email" id="email" #email="ngModel" autocomplete="email" maxlength="{{MaxLen.Email}}" placeholder="Email"
          required />
        <app-error-msg [form]="form1" [field]="email" fieldLabel="Email"></app-error-msg>
      </div>
    </div>
    <div class="row ">
      <div class="col-3  ">
        <label for="country" class="required">Country </label>
        <app-country-dropdown [(ngModel)]="model.country" name="country" #country="ngModel" id="country" appTid>
        </app-country-dropdown>
        <app-error-msg [form]="form1" [field]="country" fieldLabel="Country"></app-error-msg>
      </div>
      <div class="col-3  ">
      </div>
    </div>
    <div class="row">
      <div class="col-6  ">
        <label for="address1" class="required">Organization Address 1 </label>
        <input appScrText [(ngModel)]="model.address1" #address1="ngModel" name="address1" id="address1" placeholder="Organization Address 1" maxlength="{{MaxLen.Address}}" required
          autocomplete="billing address-line1" />
        <app-error-msg [form]="form1" [field]="address1" fieldLabel="Organization Address 1"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-6  ">
        <label for="address2">Organization Address 2 </label>
        <input appScrText [(ngModel)]="model.address2" name="address2" id="address2" placeholder="Organization Address 2" autocomplete="billing address-line2"
          maxlength="{{MaxLen.Address}}" />
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-2 ">
        <label for="city" class="required">City </label>
        <input appScrText [(ngModel)]="model.city" #city="ngModel" name="city" id="city" placeholder="City" autocomplete="billing address-line2" maxlength="{{MaxLen.City}}"
          required />
        <app-error-msg [form]="form1" [field]="city" fieldLabel="City"></app-error-msg>
      </div>
      <div class="col-2">
        <label for="state" [ngClass]="{required: model.country === 'ca' || model.country === 'us'}">State/Province</label>
        <app-region-dropdown name="state" id="state" appTid autocomplete="billing address-level1" [(ngModel)]="model.state" #state="ngModel" [country]="model.country">
        </app-region-dropdown>
        <app-error-msg [form]="form1" [field]="state" fieldLabel="State/Province"></app-error-msg>

      </div>
      <div class="col-2 ">
        <label for="zipInput" [ngClass]="{required: model.country === 'us' || model.country === 'ca'}">Zip/Postal
          Code</label>
        <app-zipcode-input name="zip" id="zip" inputId="zipInput" [(ngModel)]="model.zip" [country]="model.country" #zipModel="ngModel">
        </app-zipcode-input>

        <app-error-msg [form]="form1" [field]="zipModel" fieldLabel="Zip/Postal Code"></app-error-msg>
      </div>
    </div>
    <ng-template [appAuthIf]="[CognitoGroup.Registrant]">
      <p-checkbox name="updateOrdersApplicantContact" [(ngModel)]="updateOrdersApplicantContact" [binary]="true"
        label="Update CSC Registrant Address in all orders except those that are Paid or Cancelled."></p-checkbox>
    </ng-template>



    <!--Secondary Account Contact (Optional)  -->

    <h5 class="mt-4 mb-0">Secondary Account Contact (Optional)</h5>
    <div class="row  ">
      <div class="col-3 ">
        <label for="secondaryFirstName">First Name</label>
        <input appScrText appFirstNameValidator [(ngModel)]="model.secondaryFirstName" #secondaryFirstName="ngModel" name="secondaryFirstName" id="secondaryFirstName"
          placeholder="First Name" maxlength="{{MaxLen.FirstName}}" />
        <app-error-msg [form]="form1" fieldLabel="First Name" [field]="secondaryFirstName"></app-error-msg>
      </div>
      <div class="col-3 ">
        <label for="secondaryLastName">Last Name </label>
        <input appScrText appLastNameValidator [(ngModel)]="model.secondaryLastName" #secondaryLastName="ngModel" name="secondaryLastName" id="secondaryLastName"
          placeholder="Last Name" maxlength="{{MaxLen.LastName}}" />
        <app-error-msg [form]="form1" fieldLabel="Last Name" [field]="secondaryLastName"></app-error-msg>
      </div>
    </div>
    <div class="row ">
      <div class="col-2 ">
        <label for="secondaryPhoneInput">Phone Number</label>
        <app-phone [(ngModel)]="model.secondaryPhone" #secondaryPhone="ngModel" class="col-12" name="secondaryPhone" id="secondaryPhone"></app-phone>
        <app-error-msg [form]="form1" [field]="secondaryPhone" fieldLabel="Phone Number"></app-error-msg>
      </div>
      <div class="col-1 ps-0">
        <label for="secondaryPhoneExtension">Extension</label>
        <input appScrText maxlength="{{MaxLen.PhoneExtension}}" name="secondaryPhoneExtension" id="secondaryPhoneExtension" [(ngModel)]="model.secondaryPhoneExtension"
          placeholder="" />
      </div>
      <div class="col-3 ">
        <label for="secondaryEmail">Email</label>
        <input appScrText appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" name="secondaryEmail" id="secondaryEmail" [(ngModel)]="model.secondaryEmail" maxlength="{{MaxLen.Email}}" #secondaryEmail="ngModel"
          placeholder="Email" />

        <app-error-msg [form]="form1" [field]="secondaryEmail"></app-error-msg>
      </div>
    </div>

    <!--Primary Billing Contact (Required)  -->

    <h5 class="mt-4 ">Primary Billing Contact (Required) </h5>
    <div class="row mt-3 ">
      <div class="col-3  ">
        <app-address-book (addressChosen)="loadAddress($event)"></app-address-book>
      </div>
    </div>
    <div class="row ">
      <div class="col-3  ">
        <label for="billingFirstName" class="required">First Name</label>
        <input appScrText appFirstNameValidator [(ngModel)]="model.billingFirstName" #billingFirstName="ngModel" name="billingFirstName" id="billingFirstName"
          placeholder="First Name" maxlength="{{MaxLen.FirstName}}" required />

        <app-error-msg [form]="form1" [field]="billingFirstName" fieldLabel="First Name"></app-error-msg>
      </div>
      <div class="col-3 ">
        <label for="billingLastName" class="required">Last Name</label>
        <input appScrText appLastNameValidator [(ngModel)]="model.billingLastName" #billingLastName="ngModel" name="billingLastName" id="billingLastName" placeholder="Last Name"
          maxlength="{{MaxLen.LastName}}" required />

        <app-error-msg [form]="form1" [field]="billingLastName" fieldLabel="Last Name"></app-error-msg>
      </div>
    </div>
    <div class="row  ">
      <div class="col-2  ">
        <label for="billingPhoneInput" class="required">Phone Number </label>
        <app-phone [(ngModel)]="model.billingPhone" #billingPhone="ngModel" class="col-12" required name="billingPhone" id="billingPhone"></app-phone>
        <app-error-msg [form]="form1" [field]="billingPhone" fieldLabel="Phone Number"></app-error-msg>
      </div>
      <div class="col-1 ps-0">
        <label for="billingExtension">Extension</label>
        <input appScrText [(ngModel)]="model.billingPhoneExtension" maxlength="{{MaxLen.PhoneExtension}}" name="billingExtension" id="billingExtension" placeholder="" />

      </div>
      <div class="col-3  ">
        <label for="billingEmail" class="required">Email</label>
        <input appEmail appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" [(ngModel)]="model.billingEmail" #billingEmail="ngModel" name="billingEmail" maxlength="{{MaxLen.Email}}" id="billingEmail"
          placeholder="Email" required />
        <app-error-msg [form]="form1" [field]="billingEmail" fieldLabel="Email"></app-error-msg>
      </div>
    </div>
    <div class="row ">
      <div class="col-3  ">
        <label for="billingCountry" class="required" for="billingCountry">Country</label>
        <app-country-dropdown [(ngModel)]="model.billingCountry" name="billingCountry" id="billingCountry" #billingCountry="ngModel"></app-country-dropdown>

        <app-error-msg [form]="form1" [field]="billingCountry" fieldLabel="Country"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-6  ">
        <label for="billingAddress1" class="required">Billing Address 1 </label>
        <input appScrText [(ngModel)]="model.billingAddress1" #billingAddress1="ngModel" name="billingAddress1" id="billingAddress1" placeholder="Billing Address"
          maxlength="{{MaxLen.Address}}" required />

        <app-error-msg [form]="form1" [field]="billingAddress1" fieldLabel="Billing Address 1"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-6  ">
        <label for="billingAddress2">Billing Address 2</label>
        <input appScrText [(ngModel)]="model.billingAddress2" name="billingAddress2" id="billingAddress2" placeholder="Billing Address 2" maxlength="{{MaxLen.Address}}" />
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-2  ">
        <label for="billingCity" class="required">City </label>
        <input appScrText [(ngModel)]="model.billingCity" #billingCity="ngModel" name="billingCity" id="billingCity" placeholder="City" maxlength="{{MaxLen.City}}" required />

        <app-error-msg [form]="form1" [field]="billingCity" fieldLabel="City"></app-error-msg>
      </div>
      <div class="col-2">
        <label for="billingState" [ngClass]="{required: model.billingCountry === 'us' || model.billingCountry === 'ca'}">State/Province</label>
        <app-region-dropdown name="billingState" id="billingState" #billingState="ngModel" [(ngModel)]="model.billingState" [country]="model.billingCountry"></app-region-dropdown>
        <app-error-msg [form]="form1" [field]="billingState" fieldLabel="State/Province"></app-error-msg>
      </div>

      <div class="col-2 ">
        <label for="billingZipInput" [ngClass]="{required: model.billingCountry === 'us' || model.billingCountry === 'ca'}">Zip/Postal
          Code</label>
        <app-zipcode-input name="billingZip" id="billingZip" inputId="billingZipInput" [(ngModel)]="model.billingZip" [country]="model.billingCountry"
          #billingZipModel="ngModel"></app-zipcode-input>

        <app-error-msg [form]="form1" [field]="billingZipModel" fieldLabel="Zip/Postal Code"></app-error-msg>
      </div>
    </div>
    <ng-template [appAuthIf]="[CognitoGroup.Registrant]">
      <p-checkbox name="updateOrdersBillingContact" [(ngModel)]="updateOrdersBillingContact" [binary]="true"
        label="Update Billing Contact in all orders except those that are Paid or Cancelled."></p-checkbox>
    </ng-template>




    <!-- Program Type -->

    <ng-template [appNotAuthIf]="[CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
      <h5 class="mt-4 ">Program Type</h5>

      @if (model.programTypeReviewStatus === 'Pending') {
      <small>
        The fields in this section are disabled at this time, because your account is being evaluated for your selected Program Type.<br />
        When this evaluation is complete, you will receive a notification, and the fields will be re-enabled for editing.
      </small>
      }

      <div class="row  ms-0 mt-2">
        <label for="programTypeStandard">
          <p-radioButton name="programType" id="programTypeStandard" [(ngModel)]="model.programTypeRequested" (onClick)="programTypeChanged()" value="Standard"
            [disabled]="model.programTypeReviewStatus === 'Pending'" label="Standard"></p-radioButton>
        </label>

      </div>
      <div class="row ms-1 mb-2">
        <div class="col-6 ">
          <div class="ps-4">
            Select the Standard program type if your organization qualifies neither as a Government entity nor a
            Charitable Organization.
          </div>
        </div>
      </div>
      <div class="row  ms-0">
        <label for="programTypeGovernment">
          <p-radioButton name="programType" id="programTypeGovernment" [(ngModel)]="model.programTypeRequested" (onClick)="programTypeChanged()" value="Government"
            [disabled]="model.programTypeReviewStatus === 'Pending'" [label]="originalProgramTypeRequested === 'Government' && model.programTypeReviewStatus === 'Rejected' ? 'Government (Not Approved)' : 'Government'"></p-radioButton>
        </label>
      </div>
      <div class="row ms-1 mb-2">
        <div class="col-6 ">
          <div class="ps-4">
            Select the Government program type if your organization qualifies as a U.S. Government entity. Additional
            information is required.
          </div>
          <div *ngIf="model.programTypeRequested === 'Government'" class="expanded-panel">

            <div class="row pt-3 pb-1">
              <label for='agencyType' class="col-auto ps-0 required">Agency Type </label>
            </div>
            <div class="row radio-buttons mb-2">
              <div class="col-3 ps-0">
                <p-radioButton name="agencyType" id="agencyType" [(ngModel)]="model.governmentAgencyType" value="Federal" label="Federal"
                  [disabled]="model.programTypeReviewStatus === 'Pending'"></p-radioButton>
              </div>
              <div class="col-3">
                <p-radioButton name="agencyType" id="agencyType" [(ngModel)]="model.governmentAgencyType" value="State" label="State"
                  [disabled]="model.programTypeReviewStatus === 'Pending'"></p-radioButton>
              </div>
              <div class="col-3 ">

                <p-radioButton name="agencyType" id="agencyType" [(ngModel)]="model.governmentAgencyType" value="Local" label="Local"
                  [disabled]="model.programTypeReviewStatus === 'Pending'"></p-radioButton>
              </div>

            </div>
            <div class="row radio-buttons ">
              <div class="col-3 ps-0">
                <p-radioButton name="agencyType" id="agencyType" [(ngModel)]="model.governmentAgencyType" value="Tribal" label="Tribal"
                  [disabled]="model.programTypeReviewStatus === 'Pending'"></p-radioButton>
              </div>
              <div class="col-3">

                <p-radioButton name="agencyType" id="agencyType" [(ngModel)]="model.governmentAgencyType" value="Other" (change)="agencyTypeChanged()" label="Other"
                  [disabled]="model.programTypeReviewStatus === 'Pending'"></p-radioButton>

              </div>
            </div>

            <input type="text" name="agencyType" id="agencyType" [(ngModel)]="model.governmentAgencyType" required hidden />
            <div class="row mb-2" *ngIf="model.governmentAgencyType === 'Other'">
              <div class="col-8 ps-0">
                <label for="governmentExplain" class="required">
                  Other: Explain</label>
                <input appScrText placeholder="Other" name="governmentExplain" id="governmentExplain" #governmentExplain="ngModel" [(ngModel)]="model.governmentExplain"
                  maxlength="100" required [disabled]="model.programTypeReviewStatus === 'Pending'" />
                <app-error-msg [form]="form1" [field]="governmentExplain" fieldLabel="Other: Explain"></app-error-msg>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-9 ps-0">
                <label for="agencyWebsite">
                  Agency Web Site
                </label>
              </div>
              <div class="col-9 ps-0">
                <input appScrText appUrlValidator placeholder="URL" name="agencyWebsite" id="agencyWebsite" [(ngModel)]="model.governmentAgencyWebsite" #agencyWebsite="ngModel"
                  maxlength="150" [disabled]="model.programTypeReviewStatus === 'Pending'" />

                <span class="error-msg" *ngIf="agencyWebsite.invalid">
                  <span class="failed">This URL is invalid</span>
                </span>
              </div>
            </div>
            <div class="row  ">
              <label for="agencyInfo" class="ps-0">Additional Information</label>
            </div>
            <div class="row mb-2">
              <div class="col-9 ps-0">
                <textarea rows="8" name="agencyInfo" id="agencyInfo" [(ngModel)]="model.governmentAdditionalInfo" class="form-control" maxlength="1024"
                  [disabled]="model.programTypeReviewStatus === 'Pending'"></textarea>
              </div>
            </div>
            <div>
              <label for="governmentTermsid" class="required mt-0">
                <p-checkbox name="governmentTermsid" id="governmentTermsid" [(ngModel)]="dummy.governmentTerms" [required]="true" [binary]="true" label="Terms & Conditions"
                  #governmentTerms="ngModel" [disabled]="model.programTypeReviewStatus === 'Pending'"></p-checkbox>
              </label>
              <div class="error-msg" *ngIf="governmentTerms.touched && governmentTerms.invalid">
                <span class="failed">
                  Please read the Government Terms & Conditions and click on the box to accept.
                </span>
              </div>


            </div>
            <div class="ms-1 mb-2 ">
              <span>
                I have read and accept the Government Program Terms & Conditions.
              </span>
            </div>
            <div class="row ms-1 pb-3 me-2 pe-3">
              <span class="justify-text">
                This program is available to qualified U.S. government entities only.
                Your request will be reviewed and an email will be sent to you upon completion of the review.
                You may be required to present documentation as proof of your status, in which case you will be
                contacted by iconectiv.
                Your account will not be able to lease any new short codes under the Government pricing program prior
                to
                the
                completion of this review.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="row  ms-0">
        <label for="programTypeCharity">
          <p-radioButton name="programType" id="programTypeCharity" [(ngModel)]="model.programTypeRequested" (onClick)="programTypeChanged()" value="Charity"
            [disabled]="model.programTypeReviewStatus === 'Pending'"
            [label]="originalProgramTypeRequested === 'Charity' && model.programTypeReviewStatus === 'Rejected' ? 'Charitable Organization (Not Approved)' : 'Charitable Organization'"></p-radioButton>
        </label>
      </div>
      <div class="row ms-1 mb-2">
        <div class="col-6 ">
          <div class="ps-4">
            <span class="justify-text">
              Select the Charitable Organization program type if your organization qualifies as a 501(c)(3) entity
              that is accredited by the
              <a href="http://give.org" target="_blank">Better Business Bureau's Wise Giving Alliance</a>, or has
              at least 3 stars on <a href="http://charitynavigator.org" target="_blank">Charity Navigator</a>.
              Additional information is required.
            </span>
          </div>
          <div *ngIf="model.programTypeRequested === 'Charity'" class="expanded-panel">
            <div class="row pt-4 pb-2">
              <label for='charityAccreditation' class="required">Accreditation Organization</label>
            </div>
            <div class="row  ms-0 mb-2">
              <p-radioButton name="charityAccreditation" id="charityAccreditation" [(ngModel)]="model.charityAccreditation" value="BBB" checked
                label="Better Business Bureau Wise Giving Alliance" [disabled]="model.programTypeReviewStatus === 'Pending'"></p-radioButton>
            </div>
            <div class="row  ms-0 mb-3">

              <p-radioButton name="charityAccreditation" id="charityAccreditation" [(ngModel)]="model.charityAccreditation" value="CN34" label="Charity Navigator 3 or 4 Stars"
                [disabled]="model.programTypeReviewStatus === 'Pending'"></p-radioButton>
            </div>
            <input type="text" name="charityAccreditation" id="charityAccreditation" [(ngModel)]="model.charityAccreditation" required hidden />
            <div class="row ms-1 mb-2 pe-3">
              <span class="justify-text">
                Note: Your organization's 501(c)(3) status can be confirmed by visiting
                <a href="http://www.irs.gov/app/pub-78/" target="_blank">http://www.irs.gov/app/pub-78/</a> or by
                calling the IRS at 1-877-829-5500.
              </span>
            </div>
            <div class="row  ms-0">
              <label for="charityAdditionalInfo">Additional Information</label>
            </div>
            <div class="row  ms-0 mb-3">
              <div class="col-9">
                <textarea rows="10" name="charityAdditionalInfo" id="charityAdditionalInfo" [(ngModel)]="model.charityAdditionalInfo" maxlength="1024"
                  [disabled]="model.programTypeReviewStatus === 'Pending'" class="form-control"></textarea>
              </div>
            </div>
            <div>
              <label for="charityTermsid" class="required mt-0">
                <p-checkbox name="charityTermsid" id="charityTermsid" [(ngModel)]="dummy.charityTerms" [required]="true" [binary]="true" label="Terms & Conditions"
                  #charityTerms="ngModel" [disabled]="model.programTypeReviewStatus === 'Pending'"></p-checkbox>
              </label>
              <div class="error-msg" *ngIf="charityTerms.touched && charityTerms.invalid">
                <span class="failed">
                  Please read the Charity Organization Terms & Conditions and click on the box to accept.
                </span>
              </div>
            </div>
            <div class="row ms-1 mb-2  ms-0">
              <span>
                I have read and accept the Charitable Organization Program Terms & Conditions.
              </span>
            </div>
            <div class="row ms-1 pb-3 me-2 pe-3">
              <span class="justify-text">
                This program is available to qualified 501(c)(3) entities only.
                Your request will be reviewed and an email will be sent to you upon completion of the review.
                You may be required to present documentation as proof of your status, in which case you will be
                contacted by iconectiv.
                Your account will not be able to lease any new short codes under the Charitable Organization pricing program
                prior to completion of this review.
              </span>
            </div>
          </div>
        </div>
      </div>

      @if(originalProgramTypeRequested === 'SMB') {
      <div class="row ms-0">
        <label for="programTypeSmb">
          <p-radioButton name="programType" id="programTypeSmb" [(ngModel)]="model.programTypeRequested" (onClick)="programTypeChanged()" value="SMB"
            [label]="model.programTypeReviewStatus === 'Rejected' ? 'Small/Medium Business (Not Approved)' : 'Small/Medium Business'"
            [disabled]="model.programTypeReviewStatus === 'Pending'"></p-radioButton>

        </label>
      </div>
      <div class="row ms-1 mb-2">
        <div class="col-6 ">
          <div class="ps-4">
            <span class="justify-text">
              The Small/Medium Business program type is selected for your account,
              because your organization may qualify for this program based on the
              information provided.
            </span>
          </div>
        </div>
      </div>
      }

      <input name="programType" id="programType" [(ngModel)]="model.programTypeRequested" required hidden />

      <hr />
    </ng-template>

    <!-- Default Purchase Order Number -->
    <div *ngIf="model.monBillEnabled">
      <ng-template [appNotAuthIf]="[CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier]">
        <h5 class="mt-4 mb-0">Default Purchase Order Number</h5>
        <div class="row ms-0 mb-2 me-2">
          <div class="col-6 ps-0">
            <label for="purchaseOrder">
              Default Purchase Order Number for Monthly Billing
            </label>
            <input appScrText name="purchaseOrder" id="purchaseOrder" [(ngModel)]="model.monBillPoNumber" placeholder="Purchase Order Number" />
          </div>
        </div>
      </ng-template>
    </div>
    <ng-template #aggregatorInfoTooltipContent>
      A Direct Connection Aggregator (DCA) is any entity which delivers SMS or MMS messages from an application from
      Message Senders to wireless subscribers on a Carrier's network. The value selected here will be used to provide a
      default value for your Short Code orders. You may edit this value on the Application tab during the Checkout process,
      or by using the Edit Application Details link on the Short Codes List at any time.
    </ng-template>
    <div>
      <h5 class="mt-4 mb-0">Account Preferences</h5>
      <div class="row">
        <div class="col-md-6">
          <label for="aggregator">Default Direct Connection Aggregator
            <sup><i class="fa fa-circle-info large" style="color: #004381; margin-left: .1em;" [pTooltip]="aggregatorInfoTooltipContent"></i></sup>
          </label>
          <p-dropdown appDd [filter]="true" placeholder="Select Default Direct Connection Aggregator to use on Short Code orders." [options]="aggregators" optionLabel="name"
            optionValue="aggregatorId" name="aggregator" id="aggregator" #aggregator="ngModel" [(ngModel)]="model.defaultAggregatorId"></p-dropdown>
          <app-error-msg [field]="aggregator" fieldLabel="Default Direct Connection Aggregator"></app-error-msg>
        </div>
      </div>
      <ng-template #applicationProviderInfoTooltipContent>
        An Application Service Provider is the entity that offers individuals or enterprises access to application software
      and related services to help them create, launch, and manage messaging campaigns. The value selected here will be used to provide a 
      default value for your Short Code orders. You may edit this value on the Application tab during the Checkout process, or by using the
      Edit Application Details link on the Short Codes List at any time.
      </ng-template>
      <div class="row">
        <div class="col-md-6">
          <label for="applicationProvider">Default Application Service Provider
            <sup><i class="fa fa-circle-info large" style="color: #004381; margin-left: .1em;" [pTooltip]="applicationProviderInfoTooltipContent"></i></sup>
          </label>
          <input appScrText placeholder="Enter Default Application Service Provider to use on Short Code orders" maxlength="{{MaxLen.ApplicationProvider}}"
            [(ngModel)]="model.defaultApplicationProvider" name="applicationProvider" id="applicationProvider" #applicationProvider="ngModel" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="billingInfoRenewal">Populate Billing Information on Short Code renewals from</label>
          <p-dropdown appDd [options]="billingOnRenew" name="billingInfoRenewal" id="billingInfoRenewal" #billingInfoRenewal="ngModel"
            [(ngModel)]="model.accountBillingOnRenew"></p-dropdown>
        </div>
      </div>
      <ng-template [appAuthIf]="[CognitoGroup.Carrier]">
        <div class="row">
          <div class="col-md-6">
            <label for="recipientsInput">Recipients of the Carrier Weekly Report</label>
            <br>
            <p-chips #recipientsCWR name="recipientsCWR" id="recipientsCWR" inputId="recipientCWRInput" [(ngModel)]="model.carrierWeeklyReportEmailList"
              (onAdd)="validateChipFormat($event)" [allowDuplicate]="false" placeholder="Enter recipients' emails" [addOnBlur]="true"></p-chips>
            <!-- <app-error-msg [field]="recipientsCWR" fieldLabel="Recipients of the Carrier Weekly Report"></app-error-msg> -->
          
          </div>
        </div>
      </ng-template>
    </div>
    <!-- Agreement -->
    <h5 class="mt-4 "> Agreements</h5>
    <div>
      <label for='termAgreement' class="required mt-0">
        <p-checkbox name="termAgreement" id="termAgreement" [(ngModel)]="termAgreement" [required]="true" [binary]="true" #termAgreementCheckbox="ngModel"
          label="Terms & Conditions"> </p-checkbox>
      </label>
      <div class="error-msg" *ngIf="termAgreementCheckbox.touched && termAgreementCheckbox.invalid">
        <span class="failed">
          Please read the Registrant Sublicense Agreements and click on the box to accept.
        </span>
      </div>

    </div>
    <div class="ms-0">
      I have read and accept the &nbsp; <a [href]="licenseAgreementcontent" target="_blank">Short
        Code Registry's Registrant Sublicense Agreement</a> &nbsp; (last updated {{licenseAgreementDate}})
      <div class="terms">I acknowledge and agree that by clicking to accept the Registrant Sublicense Agreement that I am solely responsible for the accuracy
        and completeness of the information provided to the Short Code Registry, including without limitation my application information."</div>
    </div>
    <br>
    <div>
      <label for='bestPractices' class="required mt-0">
        <p-checkbox name="bestPractices" id="bestPractices" [(ngModel)]="bestPractices" [required]="true" [binary]="true" #bestPracticesCheckbox="ngModel"
          label="Best Practices"> </p-checkbox>
      </label>
      <div class="error-msg" *ngIf="bestPracticesCheckbox.touched && bestPracticesCheckbox.invalid">
        <span class="failed">
          Please read the Messages Principles and Best Practices document and click on the box to accept.
        </span>
      </div>

    </div>
    <div class="ms-0">
      I have read and accept the &nbsp;
        <a [href]="bestPracticesContent" target="_blank">
            Messaging Principles and Best Practices
        </a> &nbsp; (last updated {{ bestPracticesDate }})
    </div>
    <div class="ms-0">
      <button (click)="updateAccount(form1)" class="btn btn-primary mt-4">Update Account</button>
    </div>
  </div>
</form>